import React from 'react'
import { StyledPageTitle as S } from './PageTitle.styles'

export type TPageTitleProps = {
  children: React.ReactElement | string | number
  marginBottom?: number
  className?: string
}

export const PageTitle: React.FC<TPageTitleProps> = ({
  children,
  marginBottom,
  className = '',
}) => (
  <S.PageTitle marginBottom={marginBottom} className={className}>
    {children}
  </S.PageTitle>
)
